import React from "react";
import {Icon, Image} from "semantic-ui-react";
import {VerticalTimelineElement} from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import {companies} from './volunteerExperienceData'
import {TheatreSeason} from "./TheatreSeason";

export const Theatre = props => {
    const {data} = props;

    let mapCompanyIcon = (name, pos) => {
        const {logo, backgroundColor = 'white', top, url, companyName} = companies[name]
        return <a
            key={companyName}
            style={{backgroundColor, top: `${50 * pos}px`}}
            href={url}
            className={'vertical-timeline-element-icon-second'}>
            <Image src={logo} style={{marginTop: top}} size='tiny'/>
        </a>;
    };
    return (
        <VerticalTimelineElement
            contentStyle={{border: '1px solid #d4d4d5'}}
            contentArrowStyle={{borderRight: '0px solid #d4d4d5', top: '12px', marginRight: '1px'}}
            iconStyle={{display: 'block'}}
            icon={<>{
                data.companies.length > 6 ? <>{data.companies.filter((a, index) => index < 5).map(mapCompanyIcon)}
                        <a
                            key={'more'}
                            style={{backgroundColor: 'white', top: `${50 * 5}px`}}
                            className={'vertical-timeline-element-icon-second'}>
                            <Icon name="ellipsis horizontal" style={{marginTop: '7px', marginLeft: '4px'}} size='large'/>
                        </a>
                    </> :
                    data.companies.map(mapCompanyIcon)
            }</>}
        >
            <h3 className="vertical-timeline-element-title">{data.titles.join(" & \n")}<p>{data.roles.join(', ')}</p></h3>
            <br/>
            <TheatreSeason season={data.season}/>
            {
                data.companies.reduce(
                    (all, current) => [...all, <br key={`${current}-br`}/>,
                        <a key={`${current}-a`} href={companies[current]?.url} className="vertical-timeline-element-subtitle">{companies[current]?.companyName}</a>], [])
            }
        </VerticalTimelineElement>
    )
}
